function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './EventsWidget.css';
import React, { useContext, useEffect } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, getDictionaryItem, canUseDOM, getPageThemeColors, getColorByTheme } from '../../utils';
import getListing from "../../utils/getListing";
import { commonStyles as EventsCommonStyles } from "../15_Events/Events";
import EventBlock from "../15_Events/components/EventBlock";
import DateRange from "../Listing/DateRange";
import { filtersStylesLtr, filtersStylesRtl } from "../DynamicListingComponent/DynamicListingComponent";
import DropDown from "../Listing/DropDown";
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
import useProfile from '../../utils/hooks/useProfile';
const EventsWidget = _ref => {
  let {
    fields,
    params
  } = _ref;
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const lang = sitecoreContext && sitecoreContext.language;
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const userProfile = useProfile();
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const {
    interactionWithWidget: interactionWithWidgetAnalytics,
    seeMore: seeMoreAnalytics
  } = fields.data;
  const dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  const mapDictionary = dictionaryValues.reduce((map, currentValue) => map.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());
  const title = get(fields, 'data.datasource.widgetTitle.jss.value', 'text');
  const logo = get(fields, 'data.datasource.widgetLogo.jss.value.src', '/');
  const seeMoreText = get(fields, 'data.overviewButton.title.jss.value', 'text');
  const seeMoreURL = get(fields, 'data.overviewButton.link.jss.value.href', 'url');
  const [hits, setHits] = React.useState([]);
  const dictionary = get(fields, 'data.dictionary');
  const curatorPick = getDictionaryItem(dictionary, 'Curatorspick');
  const indexes = get(params, 'SearchIndex');
  const [selectedDateRange, setSelectedDateRange] = React.useState('');
  const [selectedFacets, setSelectedFacets] = React.useState([]);
  const [defaultFacets, setDefaultFacets] = React.useState({});
  const [facets, setFacets] = React.useState({});
  const [color, setColor] = React.useState('');
  const [grid, setGrid] = React.useState('');
  const filterWrapperRef = /*#__PURE__*/React.createRef();
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const countryItems = get(fields, 'data.countries.countryValues') || [];
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const variables = BackgroundColorHex ? {
    "--events-widget-primary-color": BackgroundColorHex,
    "--events-widget-primary-active-color": ActiveColorHex,
    "--events-widget-color": ColorHex
  } : {
    "--events-widget-primary-color": selectedPrimaryColor,
    "--events-widget-primary-active-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--events-widget-color": getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  const filters = [{
    "title": {
      "jss": {
        "value": mapDictionary.get('Categories')
      }
    },
    "fieldNameItem": {
      "item": {
        "filedName": {
          "value": "category"
        }
      }
    },
    "fieldTypeItem": {
      "item": {
        "fieldType": {
          "value": "Dropdown Multi Select"
        }
      }
    },
    "tagsToDisplay": {
      "values": []
    }
  }, {
    "title": {
      "jss": {
        "value": mapDictionary.get('Select Date')
      }
    },
    "fieldNameItem": {
      "item": {
        "filedName": {
          "value": "datesRange"
        }
      }
    },
    "fieldTypeItem": {
      "item": {
        "fieldType": {
          "value": "Date Range"
        }
      }
    }
  }];
  const setFilter = (date, type, selectedFacets) => {
    if (type === 'daterange') {
      setSelectedDateRange(date);
      tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
    } else {
      setSelectedFacets(selectedFacets || []);
    }
    ;
  };
  const filterPanelToggle = toggle => {
    if (filterWrapperRef.current) {
      if (canUseDOM) {
        if (toggle) {
          document.documentElement.style.overflowY = '';
        } else {
          document.documentElement.style.overflowY = 'hidden';
        }
      }
      if (toggle) {
        filterWrapperRef.current.classList.remove('filter__wrapper--open');
      } else {
        filterWrapperRef.current.classList.add('filter__wrapper--open');
      }
    }
  };
  const loadItems = () => {
    let urlParams = new URLSearchParams();
    if (canUseDOM) {
      urlParams = new URLSearchParams(document.location.search);
    }
    setColor(urlParams.get('color') || '6E2B62');
    switch (urlParams.get('type')) {
      case 'Horizontal':
        setGrid('col-12 col-md-6');
        break;
      case 'Horizontal Wide':
        setGrid('col-12 col-md-4');
        break;
      case 'Horizontal Double Rows':
        setGrid('col-12 col-md-4');
        break;
      default:
        setGrid('col-12');
    }
    const getCountPerPage = () => {
      const counts = {
        'Horizontal': 2,
        'Horizontal Wide': 3,
        'Horizontal Double Rows': 6
      };
      const urlType = urlParams.get('type');
      if (urlType in counts) {
        // @ts-ignore
        return counts[urlType];
      }
      return 3;
    };
    const itemFilters = {
      facets: ["datesRange", "category", "tags"],
      facetFilters: [["type:Event"]],
      hitsPerPage: getCountPerPage(),
      page: 0
    };
    if (selectedDateRange) {
      itemFilters.filters = selectedDateRange;
    }
    if (selectedFacets.length) {
      itemFilters.facetFilters.push(selectedFacets.map(facet => `category:${facet}`));
    }
    getListing(indexes, itemFilters, algoliaSettings).then(response => {
      if (!Object.keys(defaultFacets).length) {
        setDefaultFacets(response.facets);
      }
      if (!facets.category) {
        setFacets(response.facets);
      }
      setHits(response.hits);
    });
  };
  let locationSearch = '';
  if (canUseDOM) {
    locationSearch = document.location.search;
  }
  useEffect(loadItems, [selectedFacets, selectedDateRange, locationSearch]);
  if (!fields) {
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[EventsWidget component is empty: please provide datasource]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "e-widget ",
    style: _objectSpread(_objectSpread({}, variables), {
      '--widget-iframe-color': `#${color}`,
      '--date-range-primary-color': `#${color}`
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "e-widget__header"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "h3 e-widget__title"
  }, title), /*#__PURE__*/React.createElement("img", {
    src: logo,
    alt: title,
    className: "e-widget__logo"
  })), /*#__PURE__*/React.createElement("div", {
    className: "e-widget__nav",
    ref: filterWrapperRef,
    style: {
      backgroundColor: `#${color}`
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("span", {
    className: "body-medium filter__header-back-link"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "header back",
    src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgICA8cGF0aCBmaWxsPSIjMDA3Q0JBIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik03LjcxMiA0YTIuMTQgMi4xNCAwIDAgMS0uMjg0IDIuOTI3TDQuOTk2IDkuMDQ1SDE5djEuOTEzSDQuOTk2bDIuNDMyIDIuMTE2Yy44NTcuNzQ1Ljk4MSAyLjAzLjI4NCAyLjkyNkwxIDEwbDYuNzEyLTZ6Ii8+DQo8L3N2Zz4NCg=="
  })), /*#__PURE__*/React.createElement("span", {
    className: "body-medium filter__header-links filter__header-cancel-btn",
    onClick: e => {
      filterPanelToggle(e);
      tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
    }
  }, mapDictionary.get('Cancel'))), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__header-text body-medium",
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
    }
  }, /*#__PURE__*/React.createElement("span", null, mapDictionary.get('Filters')))))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, filters.map(filter => {
    const fieldNameItem = filter.fieldNameItem.item.filedName.value;
    const filterFacets = facets[fieldNameItem];
    const defaultFilterFacets = defaultFacets[fieldNameItem];
    switch (fieldNameItem) {
      case 'category':
        {
          return /*#__PURE__*/React.createElement(DropDown, {
            fields: filter,
            openWithWrapper: true,
            buttonYellow: true,
            clearAllLabel: mapDictionary.get('Clear All'),
            clearAlllFilters: true,
            widgetAnalytics: true,
            hideAmount: true,
            showLabel: mapDictionary.get('Show'),
            resultsLabel: mapDictionary.get('Results'),
            facets: filterFacets,
            facetsName: fieldNameItem,
            defaultFacets: defaultFilterFacets,
            firstFilter: true,
            nbHits: hits.length,
            firstQuery: '',
            onChangeCallback: () => {
              tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
            },
            onToggleCallback: () => {
              tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
            },
            indexDropDown: 0,
            setFilter: setFilter,
            wrapperToggle: filterPanelToggle,
            setSubpanelLabel: () => {},
            analytics: {},
            primaryColor: selectedPrimaryColor,
            resetAllFiltersCallback: () => {}
          });
        }
      case 'eventDatesRange':
        {
          return /*#__PURE__*/React.createElement(DateRange, {
            hideLabel: true,
            clearAllLabel: mapDictionary.get('Clear All'),
            clearAlllFilters: true,
            clearWithCloseWrapper: true,
            buttonYellow: true,
            widgetAnalytics: true,
            fields: filter,
            clearAllCallback: () => {},
            innerHeightAuto: true,
            showButtonColor: "var(--widget-iframe-color, var(--events-widget-primary-color))",
            showLabel: mapDictionary.get('Show'),
            resultsLabel: mapDictionary.get('Results'),
            facetsName: ['datesRange.from', 'datesRange.to'],
            setFilter: setFilter,
            onChangeCallback: () => {
              tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
            },
            onToggleCallback: () => {
              tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
            },
            wrapperToggle: filterPanelToggle,
            setSubpanelLabel: () => {},
            analytics: {
              filterSelectDateAnalytics: interactionWithWidgetAnalytics,
              params: params
            },
            lang: lang,
            primaryColor: selectedPrimaryColor
          });
        }
    }
  }).map(children => /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-4 e-widget__filter"
  }, children)), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-4 e-widget__mobile-show",
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary"
  }, mapDictionary.get('Show'), " ", mapDictionary.get('Results'))))), /*#__PURE__*/React.createElement("div", {
    className: "e-widget__body row",
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
    }
  }, hits.map(hit => /*#__PURE__*/React.createElement("div", {
    className: grid
  }, /*#__PURE__*/React.createElement(EventBlock, {
    key: hit.objectID,
    userProfile: userProfile,
    event: hit,
    widgetAnalytics: true,
    curatorsCopy: curatorPick,
    lang: lang,
    linksTarget: "_PARENT",
    removeFavButton: true,
    hostLink: '',
    analytics: {
      eventsAnalytics,
      params
    },
    multipleDates: mapDictionary.get('multipleDates'),
    countryItems: countryItems,
    themeValues: [Object.values(variables)[0], Object.values(variables)[2]]
  })))), seeMoreURL && hits.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "e-widget__see-more"
  }, /*#__PURE__*/React.createElement("div", {
    className: "see-more"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("a", {
    className: "btn btn-link see-more__link-desktop",
    "aria-label": "See More",
    "aria-labelledby": "See More",
    target: "_PARENT",
    rel: "noopener noreferrer",
    href: seeMoreURL,
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(seeMoreAnalytics, params));
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn-link__text"
  }, seeMoreText), /*#__PURE__*/React.createElement("svg", {
    className: "btn-link__icon",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--events-widget-primary-color)",
    fillRule: "nonzero",
    d: "M8.394 5.5L13 10l-4.606 4.5a1.904 1.904 0 0 1 0-2.724L10.212 10 8.394 8.224a1.904 1.904 0 0 1 0-2.724z"
  }))))), /*#__PURE__*/React.createElement("a", {
    className: "btn btn-link see-more__link-mobile",
    target: "_PARENT",
    "aria-label": "See More",
    "aria-labelledby": "See More",
    rel: "noopener noreferrer",
    href: seeMoreURL,
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(seeMoreAnalytics, params));
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn btn-primary"
  }, seeMoreText))))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    className
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${EventsCommonStyles} ${rtl ? rtlStyles : ltrStyles} ${rtl ? filtersStylesRtl : filtersStylesLtr} ${className}  `,
    "data-cy": "rich-text"
  }, children);
};
const commonStyles = "cuif8y4";
const ltrStyles = "l17qkqnn";
const rtlStyles = "rbr3l82";
export default EventsWidget;